import {Component} from '@angular/core';

@Component({
    selector: 'app-how-it-works-section',
    templateUrl: './how-it-works-section.component.html',
    styleUrls: ['../../../../assets/styles/new-styles.css', './how-it-works.component.css']
})
export class HowItWorksSectionComponent {
}
